import { entries } from 'lodash'

if (typeof Object.entries === 'undefined') {
  Object.entries = entries
}
